import { render, staticRenderFns } from "./QuaggaScanner.vue?vue&type=template&id=5dab20e0&scoped=true&"
import script from "./QuaggaScanner.vue?vue&type=script&lang=js&"
export * from "./QuaggaScanner.vue?vue&type=script&lang=js&"
import style0 from "./QuaggaScanner.vue?vue&type=style&index=0&lang=css&"
import style1 from "./QuaggaScanner.vue?vue&type=style&index=1&id=5dab20e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dab20e0",
  null
  
)

export default component.exports